const baseStyle = {}

const defaultProps = {}

const parts = ['tabsNavBar']

const sizes = {
  sm: {
    tabsNavBar: {
      borderWidth: '2px',
      fontSize: 'xs',
      h: '20px',
      py: '4px',
    },
  },
  md: {
    tabsNavBar: {
      borderWidth: '2px',
      fontSize: 'sm',
      h: '32px',
      py: '6px',
    },
  },
  lg: {
    tabsNavBar: {
      borderWidth: '3px',
      fontSize: 'md',
      h: 40,
      py: '8px',
    },
  },
  xl: {
    tabsNavBar: {
      borderWidth: '4px',
      fontSize: 'lg',
      h: 48,
      py: '10px',
    },
  },
  xxl: {
    tabsNavBar: {
      borderWidth: '4px',
      fontSize: 'lg',
      h: 56,
      py: '12px',
    },
  },
}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
